import { render, staticRenderFns } from "./EntryMessageAttachmentFile.vue?vue&type=template&id=1d00e523"
import script from "./EntryMessageAttachmentFile.vue?vue&type=script&lang=js"
export * from "./EntryMessageAttachmentFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports